import React from "react";

function productsSVGNew({ 
  isActive, 
  activeColor = "#232323",
  inactiveColor = "#868686" }:
  { isActive: boolean; activeColor?: string; inactiveColor?: string; }) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 22 22"
      fill={isActive ? activeColor : inactiveColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.15646 6.333C4.40978 5.25303 5.25303 4.40978 6.333 4.15646C6.77171 4.05355 7.22829 4.05355 7.66701 4.15646C8.74697 4.40978 9.59022 5.25303 9.84354 6.333C9.94645 6.77171 9.94645 7.22829 9.84354 7.667C9.59022 8.74697 8.74697 9.59022 7.667 9.84354C7.22829 9.94645 6.77171 9.94645 6.333 9.84354C5.25303 9.59022 4.40978 8.74697 4.15646 7.66701C4.05355 7.22829 4.05355 6.77171 4.15646 6.333Z"
        fill={isActive ? activeColor : inactiveColor}
      />
      <path
        d="M12.1565 6.333C12.4098 5.25303 13.253 4.40978 14.333 4.15646C14.7717 4.05355 15.2283 4.05355 15.667 4.15646C16.747 4.40978 17.5902 5.25303 17.8435 6.333C17.9465 6.77171 17.9465 7.22829 17.8435 7.667C17.5902 8.74697 16.747 9.59022 15.667 9.84354C15.2283 9.94645 14.7717 9.94645 14.333 9.84354C13.253 9.59022 12.4098 8.74697 12.1565 7.66701C12.0535 7.22829 12.0535 6.77171 12.1565 6.333Z"
        // fill="#868686"
        fill={isActive ? activeColor : inactiveColor}
      />
      <path
        d="M4.15646 14.333C4.40978 13.253 5.25303 12.4098 6.333 12.1565C6.77171 12.0535 7.22829 12.0535 7.66701 12.1565C8.74697 12.4098 9.59022 13.253 9.84354 14.333C9.94645 14.7717 9.94645 15.2283 9.84354 15.667C9.59022 16.747 8.74697 17.5902 7.667 17.8435C7.22829 17.9465 6.77171 17.9465 6.333 17.8435C5.25303 17.5902 4.40978 16.747 4.15646 15.667C4.05355 15.2283 4.05355 14.7717 4.15646 14.333Z"
        fill={isActive ? activeColor : inactiveColor}
      />
      <path
        d="M12.1565 14.333C12.4098 13.253 13.253 12.4098 14.333 12.1565C14.7717 12.0535 15.2283 12.0535 15.667 12.1565C16.747 12.4098 17.5902 13.253 17.8435 14.333C17.9465 14.7717 17.9465 15.2283 17.8435 15.667C17.5902 16.747 16.747 17.5902 15.667 17.8435C15.2283 17.9465 14.7717 17.9465 14.333 17.8435C13.253 17.5902 12.4098 16.747 12.1565 15.667C12.0535 15.2283 12.0535 14.7717 12.1565 14.333Z"
        fill={isActive ? activeColor : inactiveColor}
      />
    </svg>
  );
}

export default productsSVGNew;
